import { useState } from 'react'
import { VerifyOnTwitter } from '../AuthFlow/VerifyOnTwitter'
import { Modal } from '../core/Modal'
import { EditProfile } from './EditProfile'

export type EditProfileFlowPosition = 'editProfile' | 'verifyOnTwitter'

export const EditProfileFlowModal = ({
  trigger,
  open,
  onOpenChange
}: {
  trigger?: JSX.Element
  open?: boolean
  onOpenChange?: (value: boolean) => void
}) => {
  const [flowPosition, setFlowPosition] = useState<EditProfileFlowPosition>('editProfile')

  return (
    <Modal trigger={trigger} open={open} onOpenChange={onOpenChange}>
      <EditProfileFlowModalContent flowPosition={flowPosition} setFlowPosition={setFlowPosition} />
    </Modal>
  )
}

export const EditProfileFlowModalContent = ({
  flowPosition,
  setFlowPosition
}: {
  flowPosition: EditProfileFlowPosition
  setFlowPosition: React.Dispatch<React.SetStateAction<EditProfileFlowPosition>>
}) => {
  const renderFlowPosition = () => {
    switch (flowPosition) {
      case 'editProfile':
        return <EditProfile setFlowPosition={setFlowPosition} />
      case 'verifyOnTwitter':
        return <VerifyOnTwitter flowType={'editProfile'} setFlowPosition={setFlowPosition} />
    }
  }

  return renderFlowPosition()
}
